import React, { useState, useEffect } from 'react'
import { Panel, Radio, RadioGroup, Row, Col, Message } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../utils/loading'
import InputForm from '../../components/forms/input/InputForm'
import ConfirmWidget from '../confirm/ConfirmWidget'
import { useParams, useHistory } from 'react-router-dom'
import pathname from '../../constants/pathname'
import { isRequired, isValidators } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../../src/components/message/errorMessage/ErrorMessage'
import classNames from 'classnames'
import NumberFormat from 'react-number-format'
import { budgetFormat } from '../../utils/formatterUtil'
import {
  getCloseOfProjectPaymentQr,
  updateCloseOfProjectCoworkerAfterClosedForm,
} from '../../redux/actions/closeOfProject'
import notification from '../../utils/notification'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import ClosureAttachmentWidget from '../closureAttachmentWidget/ClosureAttachmentWidget'
import CountDown from '../../components/utils/CountDown'

export default function CloseProjectAfterClosedWidget({
  schema: _schema,
  evaluationId,
  notConfirmIP,
  statusConfirmActualResult,
  ...props
}) {
  const history = useHistory()
  const projectId = sessionStorage.getItem('projectId')

  const [section, setSection] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [request, setRequest] = useState()
  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues, watch } =
    useForm()
  const [formSchema, setFormSchema] = useState(_schema)
  const [interestTypeSelected, setInterestTypeSelected] = useState(
    _schema?.interestType?.value || 1
  )

  const [isShowRefundQr, setIsShowRefundQr] = useState(false)
  const [refundAmountValue, setRefundAmountValue] = useState(false)
  const [qrcodePayment, setQrCodePayment] = useState()
  const [qrcodeExpire, setQrcodeExpire] = useState()

  const [closureAttachmentNew, setClosureAttachmentNew] = useState()

  // useEffect(() => {
  //   if (!showCommandButton) {
  //     return
  //   }
  //   setIsShowRefundQr(false)
  // }, [interestTypeSelected, showCommandButton])

  useEffect(() => {
    if (_schema) {
      register(_schema?.interestType?.name, _schema?.interestType?.value || 1)
      setValue(_schema?.interestType?.name, _schema?.interestType?.value || 1)
      setInterestTypeSelected(_schema?.interestType?.value || 1)

      register(_schema?.refundAmount?.name, _schema?.refundAmount?.value)
      setValue(_schema?.refundAmount?.name, _schema?.refundAmount?.value)
      setRefundAmountValue(_schema?.refundAmount?.value)

      setClosureAttachmentNew(_schema?.closureAttachment?.fileList?.value)
    }
  }, [_schema])

  const handleShowRefundQr = async () => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await getCloseOfProjectPaymentQr(projectId, refundAmountValue, true)
      if (response.success) {
        if (response.model.expire) {
          const target = new Date(response.model.expire)
          const diffSeconds = Math.floor((target.getTime() - Date.now()) / 1000)

          setQrcodeExpire(diffSeconds)
        }

        setQrCodePayment('data:image/png;base64,' + response.model.qrCodePaymentImage)
      }
    } catch (e) {
      if (e?.response?.data) {
        notification.open('error', {
          title: e.response.data.errorMessage || DEFAULT_ERR_MSG,
          duration: 5000,
        })
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const onSubmit = (data) => {
    console.log('onSubmit data', data)

    const requiredFile =
      closureAttachmentNew?.filter((item) => {
        if (item.type == '5' && interestTypeSelected == '1') {
          //ไม่มีดอกเบี้ย = ไม่บังคับแนบ หลักฐานการโอนดอกเบี้ยเงินปิดบัญชี
          return false
        }
        return item.isRequired && item.path == null
      }) || []

    if (requiredFile.length > 0) {
      notification.open('error', {
        title: 'กรุณาแนบไฟล์เอกสารประกอบการปิดโครงการให้ครบถ้วน',
        duration: 5000,
      })
      return
    }

    let request = {
      projectVersionId: projectId,
      interestType: data[formSchema.interestType.name] || 0,
      refundAmount: data[formSchema.refundAmount.name] || 0,
    }
    setRequest(request)
    // console.log('request', request)
    setIsShowConfirm(true)
  }

  const handleCallService = async () => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await updateCloseOfProjectCoworkerAfterClosedForm(projectId, request)
      console.log('response', response)
      if (response.success || response.forms.requestNote) {
        //success jump to new page
        setIsShowConfirm(false)
        doneLoading()
        setIsLoading(false)
        // return history.push(`${pathname.proposal.overview.overviewCoworker}/${projectId}`)
        return history.push(`${pathname.proposal.overview.overviewCoworker}`)
      } else {
        notification.open('error', {
          title: response.message || DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsShowConfirm(false)
    doneLoading()
    setIsLoading(false)
  }

  const onConfirm = () => {
    console.log('onConfirm', request)
    handleCallService()
    setIsShowConfirm(false)
  }

  const onCancle = () => {
    console.log('onCancle')

    setRequest()
    setIsShowConfirm(false)
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      eventKey={2}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
    >
      {formSchema?.interestType && (
        <>
          <ErrorMessage error={errors[formSchema.interestType.name]} />
          <Controller
            key={formSchema.interestType.name}
            name={formSchema.interestType.name}
            control={control}
            rules={isValidators(formSchema.interestType.validators)}
            defaultValue={interestTypeSelected}
            value={interestTypeSelected}
            render={(props) => {
              return (
                <RadioGroup
                  value={interestTypeSelected}
                  onChange={(value) => {
                    props.onChange(value)
                    setInterestTypeSelected(value)
                  }}
                >
                  {formSchema.interestType?.options?.map((item) => {
                    return (
                      <Radio value={item.value} disabled={formSchema?.disabled}>
                        {item.label}{' '}
                      </Radio>
                    )
                  })}
                </RadioGroup>
              )
            }}
          />
        </>
      )}

      {interestTypeSelected == 2 && (
        <>
          <ErrorMessage error={errors[formSchema.refundAmount.name]} />
          <Row style={{ marginLeft: '1px' }}>
            {formSchema.refundAmount.label}
            <span>
              {' '}
              {formSchema.refundAmount.preLabel}
              {!formSchema?.disabled ? (
                <>
                  <Controller
                    name={formSchema.refundAmount.name}
                    control={control}
                    defaultValue={refundAmountValue || 0}
                    rules={isRequired ? { required: 'กรุณากรอกจำนวนเงิน' } : {}}
                    value={refundAmountValue}
                    render={(props) => {
                      return (
                        <NumberFormat
                          className={classNames(
                            'rs-input',
                            errors[formSchema.refundAmount.name] && 'is-error'
                          )}
                          thousandSeparator={true}
                          value={refundAmountValue}
                          onValueChange={(value) => {
                            props.onChange(value.floatValue)
                            setIsShowRefundQr(false)
                            setRefundAmountValue(value.floatValue)
                          }}
                          style={{ display: 'unset', width: 120, margin: '0px 15px' }}
                        />
                      )
                    }}
                  />
                  {formSchema.refundAmount.postLabel}

                  {formSchema.enableQrPayment && (
                    <SaveButton
                      icon="qrcode"
                      style={{ marginLeft: 10 }}
                      disabled={!(Number(refundAmountValue) > 0)}
                      onClick={handleShowRefundQr}
                    >
                      สร้าง QR สำหรับโอนเงิน
                    </SaveButton>
                  )}
                </>
              ) : (
                <b> {budgetFormat(formSchema.refundAmount.value)} </b>
              )}
              {formSchema?.disabled && formSchema.refundAmount.postLabel}
            </span>
          </Row>
          {qrcodePayment && (
            <Row style={{ marginTop: 10, marginLeft: '1px', textAlign: 'center' }}>
              <img
                src={qrcodePayment}
                alt="QR code for teller payment"
                style={{
                  width: 300,
                  maxWidth: '100%',
                  height: 'auto',
                  //display: 'block',
                }}
              />
              <CountDown
                second={qrcodeExpire}
                preTxt={'หมดเวลาในอีก'}
                onDone={(result) => {
                  setQrCodePayment('')
                  setQrcodeExpire(0)
                }}
              />
            </Row>
          )}
        </>
      )}

      {/* แนบไฟล์ ปิดโครงการ ตามประเภท (ใหม่) */}
      {formSchema?.closureAttachment && (
        <>
          <br />
          <ClosureAttachmentWidget
            disabledForm={formSchema?.closureAttachment.disabled}
            schema={formSchema?.closureAttachment}
            onUploadSuccess={(e) => setClosureAttachmentNew(e)}
            closeTypeSelected={interestTypeSelected}
            isAfterClosed={true}
          />
          <br />
        </>
      )}

       {!formSchema?.disabled && (
        <div style={{ marginTop: 10 }}>
          <hr />
          <SaveButton icon="save" onClick={handleSubmit(onSubmit)} children={'บันทึก'} />
        </div>
      )}

      <ConfirmWidget
        title={`ยืนยันการบันทึก`}
        show={isShowConfirm}
        detail={`กรุณายืนยันการบันทึก หากบันทึกแล้วจะไม่สามารถแก้ไขได้อีก`}
        onCancle={onCancle}
        onConfirm={onConfirm}
      />
    </Panel>
  )
}
